const DUCKDUCKGO_UA_PATTERN = /\b(Ddg|DuckDuckGo)\//;
const HYDRATION_ERROR_PATTERN = /Minified React error #418|Hydration failed because/;

export const AUTOCONSENT_PREHIDE_ID = 'autoconsent-prehide';

type Input = {
  message: string;
  userAgent: string;
  hasAutoconsentPrehide: boolean;
};

// DuckDuckGo's built-in cookie-consent blocker injects <style id="autoconsent-prehide"> into
// <head> before hydration, shifting React's head reconciliation. React recovers on its own.
// Requiring the injected element keeps genuine DuckDuckGo hydration bugs reported.
export function shouldIgnoreDuckDuckGoHydrationError({
  message,
  userAgent,
  hasAutoconsentPrehide,
}: Input): boolean {
  return (
    hasAutoconsentPrehide &&
    HYDRATION_ERROR_PATTERN.test(message) &&
    DUCKDUCKGO_UA_PATTERN.test(userAgent)
  );
}
